import translations from './translations'

translations.add('is', {
    payee: 'Viðtakandi greiðslu',
    processor: 'Úrvinnsluaðili',
    dnaPayments: 'DNA Payments Limited'
})
